// removed by extract-text-webpack-plugin
module.exports = {"floating-container":"_1JDpvX-lbzcIG90Ktm1S0I","spin":"_18wqOXN4_0NpS5fF2ouzVz"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/View/FloatingContainer/styles.scss
// module id = 881
// module chunks = 18